














import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/locales/settings";
import { changeMomentLocale } from "@/utils/moment";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component
export default class LocalesMenu extends Vue {
  currentLocale: string = localStorage?.getItem("localization") ?? "ru-RU";

  get locales() {
    return LearningMaterialLocales();
  }

  changeLocale(value: "ru-RU" | "en-EN") {
    this.currentLocale = value;
    i18n.locale = value;
    changeMomentLocale(value);
    localStorage.setItem("localization", value);
    this.$store.commit("SET_LOCALIZATION", value);
  }

  created() {
    i18n.locale = this.currentLocale;
    this.$store.commit("SET_LOCALIZATION", this.currentLocale);
  }
}
